/* AVERRO customer-review pagination. No third-party dependency. */
(function () {
  function initialize(root) {
    root.querySelectorAll('[data-av-review-list]').forEach(function (list) {
      const cards = Array.from(list.querySelectorAll('[data-av-review-card]'));
      const button = list.nextElementSibling;
      const isButton = button && button.matches('[data-av-review-more]');
      const page = Math.max(1, Number(list.dataset.avPageSize || 8));
      // Keep any cards already revealed when a section is re-initialized.
      let visible = Math.max(page, cards.filter(function (card) { return !card.hidden; }).length);
      const paint = function () {
        cards.forEach(function (card, i) { card.hidden = i >= visible; });
        if (isButton) {
          button.hidden = visible >= cards.length;
          button.setAttribute('aria-label', 'View ' + Math.min(page, Math.max(0, cards.length - visible)) + ' more reviews');
        }
      };
      if (isButton && button.dataset.avPaginationBound !== 'true') {
        button.dataset.avPaginationBound = 'true';
        button.addEventListener('click', function () {
          const showing = cards.filter(function (card) { return !card.hidden; }).length;
          visible = Math.min(cards.length, showing + page);
          paint();
        });
      }
      paint();
    });
  }
  function boot(scope) {
    (scope || document).querySelectorAll('.avr-native-reviews').forEach(initialize);
    if (scope && scope.matches && scope.matches('.avr-native-reviews')) initialize(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    const card = event.target.closest ? event.target.closest('[data-av-review-card]') : null;
    if (!card) return;
    const list=card.closest('[data-av-review-list]');
    if (!list) return;
    const cards=Array.from(list.querySelectorAll('[data-av-review-card]'));
    const n=cards.indexOf(card);
    cards.forEach(function (item,i) { if(i<=n)item.hidden=false; });
    const more=list.nextElementSibling;
    if(more&&more.matches('[data-av-review-more]')) more.hidden=cards.every(function(x){return !x.hidden;});
  });
}());